import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('notFound.title', '404 — страница не найдена')} — Mileage Riot</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content={t('notFound.desc', 'Запрошенная страница не найдена.')} />
      </Helmet>

      <section className="notfound-section">
        <div className="container">
          <div className="notfound-card">
            <p className="notfound-code">404</p>
            <h1 className="notfound-title">
              {t('notFound.heading', 'Страница не найдена')}
            </h1>
            <p className="notfound-text">
              {t('notFound.body', 'Возможно, ссылка устарела или в адресе опечатка. Проверьте адрес или вернитесь на главную.')}
            </p>
            <div className="notfound-actions">
              <Link to="/" className="btn btn-hero-primary">
                {t('notFound.home', 'На главную')}
              </Link>
              <Link to="/events" className="btn btn-hero-secondary">
                {t('notFound.events', 'К конвоям')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFoundPage;
